"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = exports.Footer = exports.Content = exports.Container = void 0;
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return _styled_modal.Modal;
  }
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styled_modal = require("./styled_modal");
var _shared = require("./shared");
var _excluded = ["ariaLabelledBy", "ariaDescribedBy", "children", "closeModal", "draggable", "modalProps", "onClose"],
  _excluded2 = ["children", "dividers", "title", "displayXIcon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StandardContainer = exports.Container = function StandardContainer(props) {
  var ariaLabelledBy = props.ariaLabelledBy,
    ariaDescribedBy = props.ariaDescribedBy,
    children = props.children,
    closeModal = props.closeModal,
    draggable = props.draggable,
    modalProps = props.modalProps,
    onClose = props.onClose,
    containerProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/React.createElement(_styled_modal.Container, (0, _extends2["default"])({
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    onClose: closeModal,
    onExit: onClose
  }, containerProps, modalProps, draggable ? {
    PaperComponent: _shared.PaperComponent
  } : {}), children);
};
StandardContainer.defaultProps = {
  ariaLabelledBy: 'modal_title'
};
var StandardHeader = exports.Header = function StandardHeader(props) {
  // Copy of TitleSection from components/modals/shared.js
  var title = props.title,
    closeModal = props.closeModal,
    displayXIcon = props.displayXIcon,
    draggable = props.draggable,
    className = props.className;
  return /*#__PURE__*/React.createElement(_styled_modal.Header, {
    className: (0, _classnames["default"])('title-section', className),
    style: {
      cursor: draggable ? 'move' : 'auto'
    }
  }, /*#__PURE__*/React.createElement(_shared.ModalTitle, {
    id: "modal_title"
  }, title), displayXIcon && /*#__PURE__*/React.createElement(_shared.CloseIcon, {
    onClick: closeModal
  }));
};
var StandardContent = exports.Content = _styled_modal.Content;
var StandardFooter = exports.Footer = _styled_modal.Footer;
var DefaultModal = function DefaultModal(props) {
  var children = props.children,
    dividers = props.dividers,
    title = props.title,
    displayXIcon = props.displayXIcon,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  return /*#__PURE__*/React.createElement(_styled_modal.Modal, null, /*#__PURE__*/React.createElement(StandardContainer, restProps, /*#__PURE__*/React.createElement(StandardHeader, (0, _extends2["default"])({
    title: title,
    displayXIcon: displayXIcon
  }, restProps)), /*#__PURE__*/React.createElement(StandardContent, {
    dividers: dividers
  }, children)));
};
DefaultModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'md',
  displayXIcon: true,
  draggable: true
};
var _default = exports["default"] = DefaultModal;